import React from 'react';
import { Button, Flex, Typography } from 'antd';

import { usePromocodeControls } from '../hooks/usePromocodeControls';
import { useAppDispatch, useAppSelector } from '../../../../../store';
import {
    clearSelection,
    selectSelected,
} from '../../../../common/store/selectionSlice';
import { PromocodeDTO } from '../service/promocodes.interface';
import { ConfirmationDialog } from '../../../../../shared/ui/ConfirmationDialog';
import { getDeclension } from '../../../../../utils/common/getDeclension';

const { Text } = Typography;

export const PromocodesActions = () => {
    const { copyPromocodes, deletePromocodes } = usePromocodeControls();
    const dispatch = useAppDispatch();

    const { selectedRowsItems = [] } = useAppSelector(selectSelected) as {
        selectedRowsItems: PromocodeDTO[];
    };

    return (
        selectedRowsItems.length > 0 && (
            <Flex vertical={false} align={'center'} gap={16}>
                <Button
                    onClick={() => copyPromocodes(selectedRowsItems)}
                    type={'primary'}
                >
                    Скопировать
                </Button>

                <ConfirmationDialog
                    activator={<Button type={'default'}>Удалить</Button>}
                    onConfirm={() => {
                        deletePromocodes(selectedRowsItems);
                        dispatch(clearSelection());
                    }}
                    title='Удалить'
                    description={`Вы уверены что хотите удалить  ${
                        selectedRowsItems.length
                    }  ${getDeclension(
                        selectedRowsItems.length,
                        ' промокод',
                        ' промокода',
                        ' промокодов'
                    )}?`}
                    withCheckbox
                />

                <Text>Выбрано: {selectedRowsItems.length}</Text>
            </Flex>
        )
    );
};
